// extracted by mini-css-extract-plugin
export var completionBody = "_iu-2";
export var completionCard = "_iu-0";
export var completionFooter = "_iu-3";
export var completionTitle = "_iu-1";